import { Injectable } from '@angular/core';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { PanAppState } from '@panamax/app-state';
import { FEATURES } from '@shared/constants/splitio-features';
import { Observable, combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DivisionPhoneNumberService {
  constructor(
    private customerStoreService: CustomerStoreService,
    readonly panAppState: PanAppState,
  ) {}

  getDivisionPhoneNumber$(
    isCustomerTypeNA: boolean,
    divisionNumber: number,
  ): Observable<string> {
    const globalFlag$ = this.panAppState.feature$([
      FEATURES.split_global_alerts_phone_nbrs.name,
    ]);
    const divisionFlag$ = this.panAppState.feature$([
      FEATURES.split_division_alerts_phone_nbrs.name,
    ]);
    const divisionPhoneData$ =
      this.customerStoreService.divisionPhoneNumber$(divisionNumber);
    let divisionPhoneNumber = '';
    return combineLatest([globalFlag$, divisionFlag$, divisionPhoneData$]).pipe(
      map(([globalFlag, divisionFlag, divisionPhoneData]) => {
        if (globalFlag && divisionFlag && divisionPhoneData) {
          divisionPhoneNumber = isCustomerTypeNA
            ? divisionPhoneData?.nationalPhoneNumber
            : divisionPhoneData?.localPhoneNumber;
        }
        return divisionPhoneNumber || '(877) 583-9659';
      }),
    );
  }
}
